export default function (value) {

	let fixed = 0;
	value = parseFloat(value);
	if (!Number.isNaN(value)) {
		return new Intl.NumberFormat('hu', { minimumFractionDigits: fixed, maximumFractionDigits: fixed }).format(value);
	} else {
		return '';
	}
}
